<ng-container [ngSwitch]="bannerType$ | async">
	<rx-banner
		class="rx-intuitive-for-doctor__read-only-banner"
		*ngSwitchCase="bannerTypes.ReadOnly"
		type="info"
		appearance="intuitive"
		[message]="'ReadOnlyMode.ReadOnlyMessage' | translate"
	></rx-banner>
	<rx-banner
		class="rx-intuitive-for-doctor__read-only-banner"
		*ngSwitchCase="bannerTypes.Resend"
		type="info"
		appearance="intuitive"
		[message]="'ReadOnlyMode.ResendScanMessage' | translate"
	></rx-banner>
</ng-container>

<rx-banner-dismissible
	*ngIf="hasResendScanError$ | async"
	type="error"
	data-testid="send-copy-error-banner"
	class="rx-intuitive-for-doctor__resend-error-banner"
	[autoDismiss]="true"
	(dismissed)="dismissResendScanError()"
>
	<span>{{ 'ResendScan.ErrorMessage' | translate }}</span>
</rx-banner-dismissible>

<rx-intuitive-patient-header *ngIf="step$ | async | mapper: shouldShowPatientHeader"></rx-intuitive-patient-header>

<ng-container [ngSwitch]="step$ | async">
	<div *ngSwitchCase="flowRxSteps.PatientDetails" [attr.data-bi-attr-flow-rx-step]="flowRxSteps.PatientDetails">
		<rx-intuitive-patient-details (patientCreated)="goToStep(flowRxSteps.ProcedureSelection)" />
	</div>

	<div
		*ngSwitchCase="flowRxSteps.ProcedureSelection"
		class="rx-procedure-tiles-container"
		[attr.data-bi-attr-flow-rx-step]="flowRxSteps.ProcedureSelection"
	>
		<rx-select-procedure (procedureSelected)="goToStep(flowRxSteps.RxForm)"></rx-select-procedure>
	</div>

	<div *ngSwitchCase="flowRxSteps.RxForm" [attr.data-bi-attr-flow-rx-step]="flowRxSteps.RxForm">
		<rx-procedure-selected-page></rx-procedure-selected-page>
	</div>

	<rx-intuitive-summary-footer
		*ngIf="isSummaryMode$ | async"
		[isContinueToLabBrokerButtonVisible]="(isContinueToLabBrokerButtonVisible$ | async) ?? false"
		[continueToLabBrokerName]="continueToLabBrokerName$ | async"
		[labBrokerSendStepBypassed]="(labBrokerSendStepBypassed$ | async) ?? false"
		(sendClicked)="sendClicked.emit()"
		(continueToLabBrokerClicked)="onContinueToLabBroker()"
	/>
</ng-container>
<div *ngIf="isResendScan$ | async" data-testid="send-copy-footer" class="rx-intuitive-for-doctor__resend-footer">
	<button tlkButton size="l" data-testid="send-copy" (click)="resendScan()" [disabled]="isResendScanDisabled$ | async">
		{{ 'ResendScan.ResendButton' | translate }}
	</button>
</div>
